/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum WebSocketStatuses {
    Unknown = 'unknown',
    Opened = 'opened',
    Closed = 'closed',
}
